import axiosInstance from './axiosInstance';

const fetchDefinitions = async ({ word, token }) => {
  const response = await axiosInstance.post(
    '/definitions',
    { word },
    { headers: { Authorization: token } }
  );
  return response.data;
};

export { fetchDefinitions };
